module.exports = __webpack_public_path__ + "img/titleen.5b8c17b7.png";